<template>
  <div>
    <label
      v-if="label && !hideLabel"
      v-tooltip.top="tooltip"
      data-testid="input-label"
      data-cy="input-label"
    >
      {{ label }}
    </label>
    <div
      v-if="label && !hideLabel && help"
      data-testid="input-help"
      data-cy="input-help"
    >
      {{ help }}
    </div>
    <PVTextarea
      :id="name"
      class="overflow-scroll"
      :class="{
        'p-invalid': isInvalid,
      }"
      :model-value="modelValue"
      :data-cy="testId"
      :data-testid="testId"
      fluid
      v-bind="$attrs"
      @input="onInput"
      @blur="onBlur"
      @keyup="$emit('keyup', $event)"
    />
    <div v-if="!hideErrorMessage" class="error-display">
      <p
        v-for="error in errors"
        :key="error"
        data-cy="warning"
        class="text-nash-brick600 text-sm"
      >
        {{ error }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import Textarea from 'primevue/textarea'
import { defineComponent } from 'vue'
import { setup } from './controller'
import { T_TEXTAREA_PROPS } from './types'

export default defineComponent({
  components: {
    PVTextarea: Textarea,
  },
  props: T_TEXTAREA_PROPS,
  emits: ['blur', 'keyup', 'update:modelValue'],
  setup,
})
</script>

<style lang="scss" scoped>
.second-border:focus {
  @apply ring-2 ring-offset-2 ring-nash-purple200;
}

textarea::placeholder {
  @apply text-nash-neutral700;
}

.p-textarea {
  @apply p-2 rounded-lg text-nash-neutral800 border border-nash-neutral500 border-1 w-full;
  @apply bg-nash-neutral000;
}

.autogrow > .p-textarea {
  field-sizing: content; /* lets the field size to its content */
  min-height: 120px;
  max-height: 750px;
  overflow: auto;
}
</style>
